import { injectIntl } from 'react-intl';
import { compose, withProps, withStateHandlers } from 'recompose';
import { FilterByLastConversationStatus, FilterByDateRange, FilterByService, FilterByCloseReason, FilterByScheduleType, FilterByAppointmentsGroup, FilterByConversationTypes } from '../../filters';
import FiltersAccordeon from './FiltersAccordeon';

const getFilters = intl => [
  {
    key: 'date',
    label: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.Date.Title',
      defaultMessage: '** Date',
    }),
    Component: FilterByDateRange,
  },
  {
    key: 'last_conversation_status',
    label: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.LastConversationStatus.Title',
      defaultMessage: '** Last conversation status',
    }),
    Component: FilterByLastConversationStatus,
  },
  {
    key: 'service',
    label: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.Service.Title',
      defaultMessage: '** Service',
    }),
    Component: FilterByService,
  },
  {
    key: 'close_reason',
    label: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.CloseReason.Title',
      defaultMessage: '** Close reason',
    }),
    Component: FilterByCloseReason,
  },
  {
    key: 'schedule_type',
    label: intl.formatMessage({
      id: 'Appointments.Filters.Schedule.Title',
      defaultMessage: '** Schedule',
    }),
    Component: FilterByScheduleType,
  },
  {
    key: 'isGroupAppointment',
    label: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.GroupOfAppointments.Title',
      defaultMessage: '** Group of appointments',
    }),
    Component: FilterByAppointmentsGroup,
  },
  {
    key: 'conversationTypes',
    label: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.ConversationType.Title',
      defaultMessage: '** Conversation type',
    }),
    Component: FilterByConversationTypes,
  },
];

export default compose(
  injectIntl,

  withProps(({ intl }) => ({
    filters: getFilters(intl),
  })),

  withStateHandlers(
    { expandedPanels: [] },
    {
      expandPanel: ({ expandedPanels }) => (expanded, panel) => ({
        expandedPanels: expanded ? [...expandedPanels, panel] : expandedPanels.filter(i => i !== panel),
      }),
    },
  ),
)(FiltersAccordeon);
